import { useOnlineStore } from '@stores/useOnlineStore';

export const userOnline = () => {
  useOnlineStore().heartBeat();
};
